import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import FacilityUnitContent from '@PROJECT_ROOT/assets/responsive-frontend/pages/FacilityUnit/FacilityUnitContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';
import AdriaticErrorBoundary from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/AdriaticErrorBoundary';
import initAfterContentComponent from '@PROJECT_ROOT/assets/responsive-frontend/js/services/AfterContentComponent';
import initMobileFixedButtonsWhereItsOnlySearch from '@PROJECT_ROOT/assets/responsive-frontend/js/services/initMobileFixedButtonsWhereItsOnlySearch';
import { PageContextProvider } from '@PROJECT_ROOT/assets/responsive-frontend/js/contexts/PageContext';

const facility = document.getElementById(pageConfig.facilityUnitPage.id);
if (facility) {
    const ssrData = window.SSR_DATA || null;
    const ssrParameters = window.SSR_PARAMETERS || null;

    hydrateRoot(
        facility,
        <AdriaticErrorBoundary>
            <GlobalPageComponents />
            <PageContextProvider userJWT={ssrParameters?.userJWT}>
                <FacilityUnitContent
                    presentationUnitSSR={ssrData}
                    serverSideRenderParameters={ssrParameters}
                />
            </PageContextProvider>
        </AdriaticErrorBoundary>,
    );
}
initAfterContentComponent();
initMobileFixedButtonsWhereItsOnlySearch();
